import { FastField } from 'formik';
import KTFormGroup from 'general/components/OtherKeenComponents/Forms/KTFormGroup';
import KTFormInput, { KTFormInputType } from 'general/components/OtherKeenComponents/Forms/KTFormInput';
import AppColors from 'general/constants/AppColors';
import { useTranslation } from 'react-i18next';
import { Row, Col, Modal } from 'react-bootstrap';
import { useState } from 'react';
import KTBSButton, { KTBSButtonColor, KTBSButtonSize, KTBSButtonType } from 'general/components/OtherKeenComponents/KTBSButton';

function CoinvestorInvestmentInfo({
    formikProps,
    commissionRateGroup,
}) {
    const { t } = useTranslation();

    const handleAddPackageCommission = (values, setFieldValue) => {
        const nextId = values.packageCommission[values.packageCommission.length - 1].id + 1;
        const updatedPackageCommission = [
            ...values.packageCommission,
            {
                id: nextId,
                revenue: 0,
                discount: 0,
            },
        ];

        setFieldValue('packageCommission', updatedPackageCommission);
    };

    const handleDeletePackageCommission = (id, values, setFieldValue) => {
        const updatedPackageCommission = values.packageCommission.filter((bonus) => bonus.id !== id);
        if (updatedPackageCommission.length === 0) {
            setFieldValue('packageCommission', [{ id: 0, revenue: 0, discount: 0 }]);
        } else {
            setFieldValue('packageCommission', updatedPackageCommission);
        }
    };

    return (
        <Row>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Doanh thu theo kW điện bán ra
                    </span>
                </Modal.Title>
            </Col>
            <Col md={6} className="pr-2">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('Dành cho ô tô')}
                        </span>
                    }
                    inputName={`energyCommissionForCar`}
                    additionalClassName=" mb-3"
                    inputElement={
                        <FastField name={`energyCommissionForCar`}>
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={'Nhập số'}
                                        isValid={_.isEmpty(meta.error)}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                        unit="VNĐ/kWh"
                                    />
                                );
                            }}
                        </FastField>
                    }
                // isRequired={true}
                />
            </Col>
            <Col md={6} className="pl-2">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('Dành cho xe máy')}
                        </span>
                    }
                    inputName={`energyCommissionForBike`}
                    additionalClassName=" mb-3"
                    inputElement={
                        <FastField name={`energyCommissionForBike`}>
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={'Nhập số'}
                                        isValid={_.isEmpty(meta.error)}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                        unit="VNĐ/kWh"
                                    />
                                );
                            }}
                        </FastField>
                    }
                // isRequired={true}
                />
            </Col>
            <Col md={12}>
                <div
                    className="my-2"
                    style={{
                        borderBottom: `1px dashed ${AppColors.gray[300]}`,
                    }}
                />
            </Col>
            <Col md={12}>
                <Modal.Title className="mb-3">
                    <span
                        className="font-weight-bolder"
                        style={{ fontSize: 18, color: AppColors.gray[900] }}
                    >
                        Doanh thu theo số phút sạc quá giờ
                    </span>
                </Modal.Title>
            </Col>
            <Col md={6} className="pr-2">
                <KTFormGroup
                    label={
                        <span
                            className="font-weight-boldest"
                            style={{
                                fontSize: 13,
                                color: AppColors.gray[800],
                            }}
                        >
                            {t('Dành cho ô tô')}
                        </span>
                    }
                    inputName={`overchargeCommissionValue`}
                    additionalClassName=" mb-3"
                    inputElement={
                        <FastField name={`overchargeCommissionValue`}>
                            {({ field, form, meta }) => {
                                return (
                                    <KTFormInput
                                        name={field.name}
                                        value={field.value}
                                        onChange={(value) => {
                                            form.setFieldValue(field.name, value);
                                        }}
                                        onBlur={() => {
                                            form.setFieldTouched(field.name, true);
                                        }}
                                        enableCheckValid
                                        type={KTFormInputType.currency}
                                        placeholder={'Nhập số'}
                                        isValid={_.isEmpty(meta.error)}
                                        isTouched={meta.touched}
                                        feedbackText={meta.error}
                                        unit="VNĐ/kWh"
                                    />
                                );
                            }}
                        </FastField>
                    }
                // isRequired={true}
                />
            </Col>
        </Row>
    )
}

export default CoinvestorInvestmentInfo;